"use client";

import { configureStore } from "@reduxjs/toolkit";

import user from "./slices/user";
import page from "./slices/page";
import university from "./slices/university";
import leaddrop from "./slices/leaddrop";
import globalslice from "./slices/globalslice";
import leaddropform from "./slices/leaddropform";

export const store = configureStore({
  reducer: {
    user,
    page,
    university,
    leaddrop,
    globalslice,
    leaddropform,
  },
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
